













































import { Component, Prop, Vue } from 'vue-property-decorator';
import { AxiosResponse } from 'axios';
import Spinner from '@/components/Spinner.vue';
import ConnectionErrorContent from '@/components/ConnectionErrorContent.vue';

export interface RecipeIdTitle {
	id: string;
	title: string;
    image: string;
}

@Component({
  components: {
    Spinner,
    ConnectionErrorContent,
  },
})
export default class Suggestions extends Vue {
    private status!: string;
    private recipeListShown!: RecipeIdTitle[];

    private data() {
        return {
            status: 'loading',
            recipeListShown: [],
        };
    }

    private created() {
        this.$store.state.btnSidebarVisible = false;
        this.$store.state.headerNavVisible = false;
        this.loadData();
        this.generateSuggestionsList();
    }
    
    private loadData() {
        this.$store.state.recipeListStatus = 'loading';
        this.status = 'loading';
        this.$store.dispatch('getRecipeList')
        .then((response) => {
            this.$store.state.recipeListShown = this.$store.state.recipeList.sort((a: any, b: any) => a.title.localeCompare(b.title));
            this.$store.state.recipeListStatus = 'success';
		}).catch((error) => {
            this.$store.state.recipeListStatus = 'error';
            this.status = 'error';
        });
    }

    private generateSuggestionsList() {
        this.status = 'loading';
        this.recipeListShown = [];
        const randIntList: number[] = [];
        for (let i = 0; i < 10; i++) {
            const randInt = Math.floor(Math.random() * this.$store.state.recipeList.length);
            let alreadyExists = false;
            for (let j = 0; j < randIntList.length; j++) {
                if (randIntList[j] === randInt) {
                    alreadyExists = true;
                }
            }
            if (alreadyExists !== true) {
                this.recipeListShown.push(this.$store.state.recipeList[randInt]);
            } else {
                i--;
            }
        }
        this.status = 'success';
    }

    private newSuggestions() {
        this.generateSuggestionsList();
    }

    private loadDataAndGenerateList() {
        this.loadData();
        this.generateSuggestionsList();
    }
}
